import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    display: flex;
    height: 100vh;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.white.primary};
    border-bottom: 1px solid ${theme.v2.colors.brand.primaryUltraLight};
    box-shadow: 0 0 16px 0 rgba(166, 182, 204, 0.10);
    display: flex;
    gap: 24px;
    justify-content: center;
    padding: 14px 0;
    width: 100%;
  `}
`;

export const ButtonDeviceWrapper = styled.button`
  appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 0;
  margin: 0;
  outline: none;
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;

  button {
    gap: 8px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const ProgressBarContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  padding-bottom: 15%;
  width: 100%;
`;

export const ProgressInner = styled.div`
  max-width: 440px;
  width: 100%;
`;

export const LoadingTitle = styled.h3`
  ${({ theme, $isTransitioning }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0 0 33px 0;
    text-align: center;
    transition: .1s ease-in-out;
    opacity: ${$isTransitioning ? 0 : 1};

    @media (min-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }

    @media (min-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.md};
    }
    
    @media (min-width: ${theme.v2.breakpoints.lg}) {
      font-size: 28px;
    }
  `};
`;

export const Content = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  flex: 1;
  padding: 32px 65px 51px;
  width: 100%;
`;

export const Iframe = styled.iframe`
  ${({ theme, $width }) => css`
    border: 1px solid ${theme.v2.colors.brand.primaryUltraLight};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.25);
    width: ${$width || '100%'};
    height: 100%;
    transition: width 0.2s ease-in-out;
    border-radius: 8px;
  `}
`;
